/** "9:12 AM" in the user's language — the "Updated …" / "checked …" time of the summary cards. */
export const formatClockTime = (iso, language = 'en') => {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleTimeString(language, { hour: 'numeric', minute: '2-digit' });
};
